import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Typography, Button, Slider, Divider, Box } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import { RotateLeft, RotateRight } from '@material-ui/icons';
import AvatarEditor from 'react-avatar-editor';
import _e from 'common/localeUtil';

const useStyles = makeStyles(theme => ({
	sliderContainer: {
		paddingTop: theme.spacing(3)
	},
	slider: {
		paddingTop: theme.spacing(1)
	},
	buttonSpacing: {
		marginRight: theme.spacing(1)
	},
	divider: {
		marginTop: theme.spacing(2),
		marginBottom: theme.spacing(2)
	},
	rotateContainer: {
		marginTop: theme.spacing(1.5)
	}
}));

const ImageEditorComponent = ({
	imageSrc,
	canvasWidth,
	canvasRatio,
	className,
	style,
	onSave,
	onCancel,
	cropperScale
}) => {
	const classes = useStyles();
	const editorRef = React.useRef();
	// eslint-disable-next-line no-unused-vars
	const [imageUrl, setImageUrl] = useState(null);
	const [scale, setScale] = React.useState(1.2);
	const [rotate, setRotate] = React.useState(0);

	const handleRotate = degree => () => {
		setRotate(rotate + degree);
	};

	const handleSave = () => {
		const img = editorRef.current.getImage().toDataURL();
		setImageUrl(img);
		onSave(img);
	};

	// const onImageChanged = () => {
	// 	console.log('New Position', canvasWidth, canvasWidth / canvasRatio);
	// 	if (editorRef.current) {
	// 		const img = editorRef.current.getImage().toDataURL();
	// 		setImageUrl(img);
	// 	}
	// };
	// const debouncedImageChanged = debounce(onImageChanged, 300);

	return (
		<div className={className} style={style}>
			<AvatarEditor
				ref={editorRef}
				image={imageSrc}
				width={canvasWidth}
				height={canvasWidth / canvasRatio}
				borderRadius={0}
				color={[0, 0, 0, 0.6]} // RGBA
				scale={scale}
				// onImageChange={debouncedImageChanged}
				rotate={rotate}
				className="editor-canvas"
				crossOrigin="anonymous"
				outBoundFillColor="transparent"
			/>

			<div className={classes.sliderContainer}>
				<Typography id="slider-zoom">Zoom</Typography>
				<Slider
					onChange={(event, newValue) => setScale(newValue)}
					step={0.01}
					min={cropperScale.min}
					max={cropperScale.max}
					value={scale}
					valueLabelDisplay="auto"
					aria-labelledby="slider-zoom"
					className={classes.slider}
					color="secondary"
				/>
			</div>

			<Box
				display="flex"
				flexDirection="row"
				justifyContent="space-between"
				alignItems="flex-end"
				className={classes.rotateContainer}
			>
				<Typography gutterBottom>Rotate</Typography>
				<div>
					<Button
						className={classes.buttonSpacing}
						color="secondary"
						variant="outlined"
						onClick={handleRotate(-90)}
						startIcon={<RotateLeft />}
					>
						Left
					</Button>
					<Button
						color="secondary"
						variant="outlined"
						onClick={handleRotate(90)}
						endIcon={<RotateRight />}
					>
						Right
					</Button>
				</div>
			</Box>

			<Divider className={classes.divider} />
			<Box display="flex" flexDirection="row">
				<Button
					className={classes.buttonSpacing}
					fullWidth
					variant="outlined"
					onClick={onCancel}
				>
					Cancel
				</Button>
				<Button
					id={`edit-image-save-button`}
					fullWidth
					variant="contained"
					color="primary"
					onClick={handleSave}
				>
					{_e('save')}
				</Button>
			</Box>
		</div>
	);
};

ImageEditorComponent.defaultProps = {
	canvasWidth: 250,
	canvasRatio: 1,
	cropperScale: {
		min: 1,
		max: 3
	}
};

ImageEditorComponent.propTypes = {
	imageSrc: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
	className: PropTypes.string,
	style: PropTypes.object,
	onSave: PropTypes.func.isRequired,
	onCancel: PropTypes.func.isRequired,
	canvasWidth: PropTypes.number,
	canvasRatio: PropTypes.number,
	cropperScale: PropTypes.shape({
		min: PropTypes.number.isRequired,
		max: PropTypes.number.isRequired
	})
};

export default ImageEditorComponent;
